import { render, staticRenderFns } from "./StepCusLegalAgent.vue?vue&type=template&id=7c1ec345"
import script from "./StepCusLegalAgent.vue?vue&type=script&lang=js"
export * from "./StepCusLegalAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports